<ng-template #templateLoading>
  <div class="pgpp-loading-content" role="status" aria-live="polite">
    <div class="br-loading medium" role="progressbar" aria-label="Carregando"></div>
    <p *ngIf="message()">{{ message() }}</p>
  </div>
</ng-template>
